import React, { useState } from "react";
import AsideMenu from "../Aside/AsideMenu/AsideMenu";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AsideMenuHome } from "./AsideMenu/AsideMenuHome";
import { Link } from "react-router-dom";
import withRouter from "../../CommonComponents/WithRouter";
import { shallowEqual, useSelector } from "react-redux";
import { SW_LOGO, SW_LOGO_ICON } from "../../../actions/api";
import { Image } from "react-bootstrap";


function Aside(props) {
	const [isActive, setActive] = useState("false");
	const [detailedView, setDetailedView] = useState(true);
	const { widgetWallsData } = useSelector(state => state.wallReducer, shallowEqual);
	const { userData } = useSelector(state => state.authenticated, shallowEqual);
	const location = useLocation();
	const { pathname } = location;
	const arry = pathname.split("/");

	const wallData = widgetWallsData && Object.keys(widgetWallsData).length > 0 ? localStorage.getItem('wallId') ? widgetWallsData.filter(wall => wall.id == (localStorage.getItem('wallId')))[0] : null : null;


	const user = userData && Object.keys(userData).length > 0 ? userData.user : null;
	const conditions = ["index", "analytic", "preview", 'publish', 'personalize', 'authCallback', 'feeds', 'trusense', 'studio', 'snapup', 'photobooth'];
	const path = location.pathname;
	const setIsShown = (ele) => {
		setActive(isActive);
		if (document.body.classList.contains("aside-minimize") && ele) {
			document.body.classList.remove('aside-minimize');
			document.body.classList.add('aside-minimize-hover');
		} else {
			if (document.body.classList.contains("aside-minimize-hover") && !ele) {
				document.body.classList.remove('aside-minimize-hover');
				document.body.classList.add('aside-minimize');
			}
		}
	};

	useEffect(() => {
		if (String(arry).toLowerCase().includes("studio")) {
			window.$("body").addClass('subheader-fixed subheader-enabled');
		} else {
			window.$("body").removeClass('subheader-fixed subheader-enabled');
		}

		getPath();
	}, [location.pathname]);

	const getPath = () => {
		if (conditions.some(el => path.includes(el)) && !path.includes("extrawallfeeds")) {
			setDetailedView(true);
		} else {
			setDetailedView(false);
		}
	}

	return <>
		<div show={String(props.sidebarMobileMenu)} className={`aside aside-left aside-fixed bg-white position-fixed top-0 bottom-0 box-shadow ${props.sidebarMobileMenu ? 'aside-on' : ''}`} onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
			<div className="d-flex brand border-end border-bottom px-3" id="kt_brand">
				<Link to={JSON.parse(localStorage.getItem('isCollaborator')) == 0 ? `/walls/home` : `/walls`} className="d-flex align-items-center overflow-hidden sw_brand_link">
					<Image className="h-auto sw_brand_full" src={SW_LOGO} alt="logo" width={'136'} height={'46'} />
					<Image className="h-auto sw_brand_icon" src={SW_LOGO_ICON} alt="logo" width={'32'} height={'32'} />
				</Link>
			</div>
			<div className="aside-menu-wrapper border-end flex-grow-1 position-relative" id="kt_aside_menu_wrapper">
				{detailedView ? <AsideMenu prefix={props.prefix} key={props.prefix} wallData={wallData} /> : <AsideMenuHome prefix={props.prefix} key={props.prefix} user={user} />}
			</div>
		</div>

		{props.sidebarMobileMenu ?
			<div className="aside-overlay" onClick={() => window.$("#kt_aside_mobile_toggle").click()}></div>
			: null
		}
	</>

}


export default withRouter(React.memo(Aside))